export default {
    yAxis: [{
        title: {
            text: ''
        },
        categories: "",
        labels: {
            formatter: function () {
                var label = this.axis.defaultLabelFormatter.call(this);
                return label/1000 + ' Mil.';
            },
            format: '{value}',
            style: {
                color: '#b0b6c3',
                fontSize: '15px'
            }
        },
        opposite: false
    }],
    series: [{
        name: function(){
            if(document.documentElement.lang == 'cz'){
                return "Obrat"
            }
            else{
                return "Turnover"
            }
            
        }(),
        data: [100251, 69333, 110179, 127744, 234187, 416798, 509858, 1076000, 1403010, 1455928, 1490402, 1575400, 2461304, 3158362],
        marker: {
            enabled: false
        },
    }],
}

//847474


// WEBPACK FOOTER //
// ./data/charts/obrat.js